import React from "react";

const YesNoLeaningComponent = ({ actions }) => {

    return (
        <div className="flex flex-col items-center">
            <div className="flex flex-col space-y-4 mt-4">
                <button
                    className="text-white px-4 py-2 rounded"
                    style={{ background: "#5CCC9D" }}
                    onClick={() => {
                        actions.provideArticleLeaningInfo();
                    }}
                >
                    Yes, please.
                </button>
                <button className="text-white px-4 py-2 rounded" onClick={() => actions.handleLeaningNo()} style={{ background: "#5CCC9D" }}>
                    No, thank you.
                </button>
            </div>
        </div>
    );
};

export default YesNoLeaningComponent;
